"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AperturaEditorial() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="227835" id="apertura-editorial" className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-background text-foreground py-24 md:py-32">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      opacity: 0.12
    }} aria-hidden="true" />

      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 md:px-6 text-center flex flex-col items-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <blockquote className="font-serif text-3xl md:text-5xl lg:text-6xl font-normal italic text-foreground leading-tight max-w-4xl">
          "Dadme un punto de apoyo y moveré el mundo."
        </blockquote>

        <p className="font-mono text-xs md:text-sm text-muted-foreground tracking-widest uppercase mt-8">
          — Arquímedes · 250 a.C.
        </p>
      </div>
    </section>;
}